// Centralized route paths. Use these constants instead of hardcoding URLs.
export const PATHS = Object.freeze({
  // public
  HOME: '/',
  PRODUCTS: '/products',
  CATEGORY: '/category/:slug',
  PRODUCT: '/product/:slug',
  DEALS: '/deals',
  NEW_ARRIVALS: '/new-arrivals',
  BRANDS: '/brands',
  BLOG: '/blog',
  BLOG_DETAIL: '/blog/:slug',
  ABOUT: '/about',
  CONTACT: '/contact',
  SUPPORT: '/support',
  CART: '/cart',
  CHECKOUT: '/checkout',
  INQUIRY: '/inquiry',
  SEARCH: '/search',
  PRIVACY: '/privacy-policy',
  TERMS: '/terms-conditions',
  RETURN: '/return-policy',
  SHIPPING: '/shipping-policy',
  WARRANTY: '/warranty-policy',

  // auth
  LOGIN: '/login',
  REGISTER: '/register',
  VERIFY_EMAIL_OTP: '/verify-email-otp',
  FORGOT_PASSWORD: '/forgot-password',

  // customer
  ACCOUNT: '/account',
  CUSTOMER_PROFILE: '/account/profile',
  CUSTOMER_ORDERS: '/account/orders',
  CUSTOMER_ORDER_DETAILS: '/account/orders/:id',
  CUSTOMER_INQUIRIES: '/account/inquiries',
  CUSTOMER_INQUIRY_DETAILS: '/account/inquiries/:id',
  CUSTOMER_WISHLIST: '/account/wishlist',
  CUSTOMER_COMPARE: '/account/compare',
  CUSTOMER_ADDRESSES: '/account/addresses',
  CUSTOMER_PASSWORD: '/account/change-password',

  // admin
  ADMIN_LOGIN: '/admin/login',
  ADMIN: '/admin',
  ADMIN_DASHBOARD: '/admin/dashboard',

  // marketer
  MARKETER: '/marketer',
  MARKETER_DASHBOARD: '/marketer/dashboard',
});
